<div class="quarterly-feedback-container">
  <emerald-tab-bar [tabsData]="tabsData" class="custom-green" [showContent]="true"
    (selectedTabChange)="onTabChange($event)"></emerald-tab-bar>

  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.Compliance">
    <div class="compliance-section">
      <div class="rto-compliance-card">
        <h3>RTO Compliances</h3>
        <app-rto-bar-chart [vendorId]="vendorId"></app-rto-bar-chart>
        <div class="legend">
          <span class="compliant-dot"></span> Compliant
          <span class="non-compliant-dot"></span> Non Compliant
        </div>
      </div>
      <div class="general-compliance-card" *ngIf="hasLevel2Or3Access">
        <div class="header">
          <h3>General Compliances</h3>

          <div class="filter">
            <emerald-dropdown [options]="monthOptions" [outlined]="true" [id]="'single_select'" [label]="'Month'"
              (onChange)="onQuarterChange($event)"></emerald-dropdown>
          </div>
        </div>
        <div class="items-container">
          <div class="item" *ngFor="let item of generalComplianceCards">
            <div class="label-row">
              <span class="label">{{ item.label }}</span>
              <a (click)="downloadFile(item.fileUrl, item.label); $event.preventDefault()">
                <img class="logo" src="../../../../../assets/icons/excel.svg" alt="Download Excel" />
              </a>
            </div>
            <span class="value" [class.red]="item.highlight">{{ item.value }}</span>
          </div>
        </div>
      </div>
      <div class="spacer"></div>
    </div>
  </div>
  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.PeopleMetrics">
    <div class="placeholder-tab-content">
      <app-people-metrics [vendorId]="vendorId"></app-people-metrics>
    </div>
  </div>
  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.LearningDevelopment">
    <app-learning-development [vendorId]="vendorId"></app-learning-development>
  </div>
 <div *ngIf="(selectedTab?.label ?? '') === tabLabels.StrategicPartnership && hasLevel2Or3Access">
  <div class="compliance-section">
    <app-strategic-partnership [vendorId]="vendorId"></app-strategic-partnership>
    <div class="spacer"></div>
  </div>
</div>
</div>
